export const META_DESCRIPTION_MAX_LENGTH = 160

export const stripHtml = (html) => {
  if (!html) return ''
  const text =
    typeof DOMParser !== 'undefined'
      ? new DOMParser().parseFromString(html, 'text/html').body.textContent
      : html.replace(/<[^>]*>/g, ' ')
  return (text || '').replace(/\s+/g, ' ').trim()
}

export const truncate = (text, maxLength = META_DESCRIPTION_MAX_LENGTH) => {
  if (!text || text.length <= maxLength) return text || ''
  const cut = text.slice(0, maxLength - 3)
  const lastSpace = cut.lastIndexOf(' ')
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(/[\s.,;:!?-]+$/, '')}...`
}

const formatLocation = (address) =>
  address ? [address.city, address.stateOrProvince].filter(Boolean).join(', ') : ''

export const getPostingMetaDescription = (posting = {}) => {
  const company = posting.brand || posting.clientName
  const location = formatLocation(posting.address)
  const summary = [posting.positionType, company && `at ${company}`, location && `in ${location}`]
    .filter(Boolean)
    .join(' ')
  const details = stripHtml(posting.description)
  return truncate([summary && `${summary}.`, details].filter(Boolean).join(' '))
}

export const getCareerPageMetaDescription = (clientName, pageTitle) => {
  const company = clientName || pageTitle
  return company ? truncate(`Explore career opportunities and apply for jobs at ${company}.`) : ''
}
